import LegalLayout from "./LegalLayout";
export default LegalLayout;
